module.exports = __webpack_public_path__ + "static/media/mobileScreenshot03.d568cf99.jpg";